import type { DoctrineId } from '../data/doctrines.js';

import type { PlayerId } from './ids.js';

// V0.2 PlayerState: signal/income are live. V1.5 introduces doctrineId — null
// until the player picks (or is auto-assigned the default at window close).
export interface PlayerState {
  id: PlayerId;
  name: string;
  isBot: boolean;
  signal: number;
  signalScore: number;
  signalIncomePerSec: number;
  peakIncomePerSec: number;
  squadCap: number;
  squadCount: number;
  doctrineId: DoctrineId | null;
}

export function createPlayerState(
  id: PlayerId,
  args: { name: string; isBot: boolean; squadCap: number },
): PlayerState {
  return {
    id,
    name: args.name,
    isBot: args.isBot,
    signal: 100,
    signalScore: 0,
    signalIncomePerSec: 0,
    peakIncomePerSec: 0,
    squadCap: args.squadCap,
    squadCount: 0,
    doctrineId: null,
  };
}
